
const TipsAndTricksDrawer = () => {
    return (
        <div></div>
    )
};

export default TipsAndTricksDrawer;